import { render } from "./LayoutComponent.vue?vue&type=template&id=1b6e0d75&ts=true"
import script from "./LayoutComponent.vue?vue&type=script&lang=ts"
export * from "./LayoutComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__